import { ShieldTeam } from './ShieldTeam';

import baseShieldTshirt from '@/assets/baseShieldTshirt.svg';
import imageShirt from '@/assets/roundNeck.png';
import icClarin from '@/assets/sponsors/ic_clarin.png';
import icPolo from '@/assets/sponsors/ic_neck-polo.png';
import icRounded from '@/assets/sponsors/ic_neck-rounded.png';
import icVe from '@/assets/sponsors/ic_neck-ve.png';
import icOle from '@/assets/sponsors/ic_ole.png';
import icTn from '@/assets/sponsors/ic_tn.png';
import tshirtdUtils from '@/modules/edit-my-account/components/my-team/tshirtAssets';
import { enforceMinBrightness } from '@/modules/edit-my-account/functions/utils';
import { defaultTshirtTeam } from '@/store/tshirtAndShield';
import { PropsWithClassName } from '@/types';
import { SvgCamiseta, SvgEscudo } from '@/types/editProfile';

type TshirtProps = PropsWithClassName<{
  id?: number | string;
  withShield?: boolean;
  tshirt?: SvgCamiseta;
  shield?: SvgEscudo;
}>;

export const TshirtTeam = ({ id, tshirt, shield, withShield }: TshirtProps) => {
  const getNeckId = (id: number) => {
    if (!id || !tshirt?.param1) return 'none';
    if (tshirt?.param1)
      return parseInt(tshirt?.param1) === id ? 'inline' : 'none';
  };

  const getSponsorId = (id: number) => {
    if (!id || !tshirt?.param5) return 'none';
    if (tshirt?.param5)
      return parseInt(tshirt?.param5) === id ? 'inline' : 'none';
  };

  return (
    <svg
      id={String(id)}
      viewBox="0 0 208.83 261.83"
      width="100%"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {/* mask camiseta */}
      <defs>
        <path
          d="M41.17,108.1l-.32,4.32s-.65,1.55-2.52,1.61c0,0-25.87-1.03-33.48-5.23,0,0-1.87-.9-.84-3.94,0,0,2.19-12.58,2.19-14.9,0,0,.77-15.29,2.13-19.55,0,0,0-15.87,7.16-24.58,0,0,11.61-12.77,29.42-18.39l34.45-14.52s0,25.16,26.9,25.16c0,0,25.16,2.13,25.16-25.16,0,0,38.71,15.48,44.32,21.87,0,0,13.55,5.81,20.32,15.1,0,0,6,13.16,6,23.61,0,0,.77,16.06,1.74,18,0,0,1.55,10.39,1.35,14.58,0,0-9.48,8.06-35.03,5.55l-.39-3.87-3.74-4.45-2.06,35.81-1.42,11.87s2.32,18.06,3.1,20.9,1.55,28.39,1.16,31.74c0,0,1.29,13.81.39,19.23,0,0,1.03,29.29,1.94,30.19s-3.42,5.6-63.81,5.6,0,.85,0,.85c0,0-58.26-1.74-65.42-4.26l1.94-46.74,1.74-48.68v-31.74s.24-18,.24-18l-2.63-2Z"
          // fill="#303030" maximo camisetas negras
          fill={`#${enforceMinBrightness(
            tshirt?.param3 || defaultTshirtTeam.param3
          )}`}
          id={`shield-path-${String(id)}`}
        />
        <clipPath id="tshirt-clipPath">
          <use overflow="visible" xlinkHref={`#shield-path-${String(id)}`} />
        </clipPath>
      </defs>
      {/* END mask camiseta  */}

      <g>
        {/* <!-- END tramas --> */}
        <g>
          <use href={`#shield-path-${String(id)}`} />

          {/* <!-- tramas --> */}
          <g id="tramasCamiseta">
            <path
              clipPath="url(#tshirt-clipPath)"
              d={
                tshirtdUtils.tshirtPatterns[
                  Number(tshirt?.param2 || defaultTshirtTeam.param2)
                ]?.path
              }
              fill={`#${enforceMinBrightness(
                tshirt?.param4 || defaultTshirtTeam.param4
              )}`}
              id={String(tshirt?.param2)}
            />
          </g>

          <image
            height="365"
            href={imageShirt}
            overflow="visible"
            style={{ mixBlendMode: 'multiply' }}
            transform="translate(3.08 12.08) scale(.68)"
            width="300"
          />

          {/* <!-- cuellos  --> */}
          <g id="cuellos">
            <image
              display={getNeckId(1)}
              height="42"
              href={icRounded}
              id="cuello1"
              style={{ transform: 'translate(69px, 4px)' }}
              width="69"
            />
            <image
              display={getNeckId(2)}
              height="42"
              href={icVe}
              id="cuello1"
              style={{ transform: 'translate(69px, 8px)' }}
              width="69"
            />
            <image
              display={getNeckId(3)}
              href={icPolo}
              id="cuello1"
              style={{ transform: 'translate(67px, 4px)' }}
              width="75"
            />
          </g>

          {/* <!-- END cuellos --> */}
        </g>
        {/* <!-- sponsors --> */}
        {withShield && tshirt?.param5 && (
          <g transform="translate(0,15)">
            <image
              display={getSponsorId(1)}
              height="42"
              href={icOle}
              id="sponsor1"
              style={{ transform: 'translate(50px, 105px)' }}
              width="108"
            />
            <image
              display={getSponsorId(4)}
              height="46"
              href={icClarin}
              id="sponsor4"
              style={{ transform: 'translate(55px, 102px)' }}
              width="98"
            />
            <image
              display={getSponsorId(3)}
              height="19"
              href={icTn}
              id="sponsor3"
              style={{ transform: 'scale(.9) translate(62px, 130px)' }}
              width="108"
            />
            {/* <!--  FIN  sponsors --> */}
          </g>
        )}
      </g>

      <g>
        {/* <!-- Escudo --> */}

        {withShield &&
          (shield?.escudoparam1 ? (
            <g transform="translate(115, 52) scale(0.19)">
              <ShieldTeam
                backgroundColor={`#${shield.escudoparam4}`}
                id={shield.escudoparam1}
                pattern={shield.escudoparam2}
                patternColor={`#${shield.escudoparam3}`}
                textContent={shield.escudoparam5}
              />
            </g>
          ) : (
            <g>
              <image
                href={baseShieldTshirt}
                overflow="visible"
                transform="scale(2) translate(-15,-10)"
                width="100%"
              />
            </g>
          ))}
        {/* <!-- END escudo --> */}
      </g>
    </svg>
  );
};
